module.exports = __webpack_public_path__ + "img/liuxiajun.b8ea17c5.jpg";